<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        darkMode: window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
      }
    },
    mounted() {
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
        this.darkMode = e.matches;
      });
    }
  }
</script>

<style>
  @import url("https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap");
  @import "~bootstrap/dist/css/bootstrap.min.css";
  @import "~@fortawesome/fontawesome-free/css/all.css";

  html {
    height: 100vh;
  }
  body {
    height: 100%;
    overflow: hidden;
  }

  #app {
    font-family: 'Roboto', Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    width: 100%;
    height: 100%;
  }



  a {
    color: var(--bs-info);
  }

  .mouse-hand {
    cursor: pointer !important;
  }
</style>
